import React, { useContext } from "react"
import { NavLink, useNavigate } from "react-router-dom"
import { UserContex } from "../App"

const items = [
  ["Overview", "/dashboard"],
  ["Properties", "/realestatedashboard"],
  ["Leads & viewings", "/realestateorders"]
]

export default function SideNav() {
  const navigate = useNavigate()
  const { dispatch } = useContext(UserContex)
  const user = JSON.parse(localStorage.getItem("admin") || "null")
  const logout = () => {
    localStorage.removeItem("jwt")
    localStorage.removeItem("admin")
    dispatch({ type: "CLEAR" })
    navigate("/login")
  }

  return <aside className="flex w-full flex-col bg-slate-950 text-white lg:min-h-screen lg:w-64 lg:flex-none">
    <div className="flex items-center justify-between px-5 py-5 lg:block">
      <div className="flex items-center gap-3"><img src="/brand/saamling-mark-dark.jpg" alt="" className="h-10 w-10 rounded-xl object-cover"/><div><div className="font-bold">Saamling</div><div className="mt-1 text-xs text-slate-400">Broker workspace</div></div></div>
      <button onClick={logout} className="text-xs text-slate-400 lg:hidden">Log out</button>
    </div>
    <nav className="flex gap-2 overflow-x-auto px-3 pb-4 lg:flex-col lg:pt-5">
      {items.map(([label, path]) => <NavLink key={path} to={path} className={({ isActive }) => `whitespace-nowrap rounded-xl px-4 py-3 text-sm font-semibold ${isActive ? "bg-emerald-700 text-white" : "text-slate-400 hover:bg-slate-900 hover:text-white"}`}>{label}</NavLink>)}
    </nav>
    <div className="mt-auto hidden border-t border-slate-800 p-5 lg:block">
      <p className="truncate text-sm font-semibold">{user?.name}</p><p className="truncate text-xs text-slate-500">{user?.email}</p>
      <button onClick={logout} className="mt-4 text-sm font-semibold text-slate-300 hover:text-white">Log out</button>
    </div>
  </aside>
}
